import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<p>{`The caption component can be used to append a caption to images used in documentation.`}</p>
<h2>{`Usage`}</h2>
<p><inlineCode parentName="p">{`Caption`}</inlineCode>{` is a `}<a parentName="p" {...{
        "href": "https://mdxjs.com/blog/shortcodes"
      }}>{`shortcode`}</a>{`, meaning it's globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files. So you can use the `}<inlineCode parentName="p">{`Caption`}</inlineCode>{` component in any `}<inlineCode parentName="p">{`.md`}</inlineCode>{` or `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` file without importing it.`}</p>
<h2>{`Example`}</h2>
<pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex" alignItems="center" flexDirection="column">
  <img
    alt=""
    src="https://s3.us-west-2.amazonaws.com/photos.puppyspot.com/breeds/245/card/500000291_medium.jpg"
  />
  <Caption>A beautiful husky puppy.</Caption>
</Box>
`}</code></pre>
<Note variant="warning" mdxType="Note">
<p>{`Be sure to provide enough detail in your caption so users with assistive technology have adequate context. An empty alt tag `}<inlineCode parentName="p">{`alt=""`}</inlineCode>{` should be used on the `}<inlineCode parentName="p">{`img`}</inlineCode>{` in cases where the caption describes the image, thus making the image decorative in purpose.`}</p>
</Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      